import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import Download from 'assets/icon/Download.svg';
import DownloadHover from "assets/icon/download_hover.svg";
import HoverImage from 'react-hover-image/build';
import { Button } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ViewConfigurations from '../ViewConfigurations';
import Drawer from 'components/Drawer';
import { toast } from 'react-toastify';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import useAxios from 'hooks/useAxios';
import collapse from 'assets/icon/collapse-icon.svg';
import collapseclose from 'assets/icon/collapse-icon-close.svg';
import Filters from 'components/Filters';
import viewIcon from 'assets/icon/view-icon.svg';
import viewHoverIcon from 'assets/icon/view-Hover-icon.svg';
import Loader from 'components/Loader';

let tableDataBackup = []
let rowForEdit = {};

const ConfigurationTable = (props) => {

  const {
    manvalConfigedit,
    manvalConfig,
    manvalPharmacy,
    manvalPharacy,
    onExport,
    collapseSider,
    manval,
    data,
    onSearch,
    filters,
    totalSize,
    onPageChange,
    setFilterShow,
    filtershow,
    fetchConfiguration,
    startPage,
    setStartPage,
    selectedValues,
    setSelectedValues,
    sort,
    setSort,
    ceid,
    reportId,
    appid,
    loading,
  } = props;

  tableDataBackup = data
  const [tableData, setTableData] = useState(tableDataBackup);
  const [isOpenView, setOpenView] = useState(false);
  const [selectedRow, setselectedRow] = useState({});
  const [mfg, setmfg] = useState()
  const [state, updateState] = useState({
    filters: filters,
  });
  const API = useAxios();

  const handelAddCoveredEntity = async (rowData) => {
    await manvalPharmacy();

  }
  const toggleSider = async () => {
    await manval();
  }

  // const handleExport = async (rowData) => {
  //      try{
  //         const action = await axios.get(`https://localhost:7113/api/Report/download/${rowData.reportTypeID}`);
  //     }
  //     catch(error){
  //         console.log(error)

  //     }

  // };

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...tableDataBackup];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.reportConfigID === rowData?.reportConfigID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    tableDataBackup = tempData;
    setTableData(tempData);
  };

  const cellRenderEdit = (rowData) => {
    return( < div className='d-flex align-items-center'>
      { rowData.endDate == null &&
      <CellOptions row={rowData} editTitle="Edit Term Date" saveTitle="save Term Date" onEdit={editRow} onSave={saveUpdateRow} />
    }
      {renderViewButton(rowData)}
      </div>
      )
  }

  const renderViewButton = (rowData) => {
    return (
        <Button
            className='edit text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => toggleView(rowData)}
            title='View Configurations'
        >
            <HoverImage
                key='EyeIcon'
                src={viewIcon}
                hoverSrc={viewHoverIcon}
                alt=''
            />
        </Button>
    );
};

const toggleView = (rowData) => {
  setOpenView(!isOpenView);
  setselectedRow(rowData);
};

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        formatterType={formatterType}
        onChange={updateRowValue}
      />
    );
  }

  const checkvalidation = (selectedvaluesonly) => {
    if (!selectedvaluesonly.endDate) {
      toast.error('Please select End Date')
      return true
    }
    let endDate = new Date(selectedvaluesonly.endDate);
    if (isNaN(endDate)) {
      toast.error('Please select a valid End Date');
      return true;
    }
    const endDateStr = String(selectedvaluesonly.endDate)
    const [endMonth, endDay, endYear] = endDateStr.split('/');
    endDate = new Date(`${endYear}-${endMonth}-${endDay}`);
    const startDate = new Date(rowForEdit.startDate);
    if (endDate < startDate) {
      toast.error('End Date should be greater than start Date');
      return true;
    }
    const todayDate = new Date()
    if (endDate < todayDate) {
      toast.error('End Date should be Today or Future Dates');
      return true;
    }
    else {
      return false;
    }

  }

  const saveUpdateRow = async () => {
    if (checkvalidation(rowForEdit))
      return true;

    let payload = { ...rowForEdit };
    delete payload.isEdit;
    try {
      const response = await API.post(
        `api/Report/editConfig`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      if (response.data === true) {
        toast.success('Term date updated Successfully');
        fetchConfiguration(filters);
      } else {
        toast.error('Failed to add configurations');
      }

    } catch (error) {
      console.log(error);
    }
  };

  const ManufacturesArrayList = (row) => {
    const displayLimit = 1;
    if (row.reportConfigMfgMaps.length === 0) {
      return '-';
  }
    const displayedManufacturers = row.reportConfigMfgMaps.slice(0, displayLimit);
    const hiddenManufacturers = row.reportConfigMfgMaps.slice(displayLimit);
    return (
      <div>
        {displayedManufacturers.map((manufacturer, index) => (
          <Badge
            key={index}
            pill
            bg="secondary"
            style={{
              marginRight: '8px',
              padding: '10px',
              color: "#555555",
              margin: "auto",
              width: "auto",
            }}
          >
            {manufacturer.manufacturerName}
          </Badge>
        ))}
        <div>
          {hiddenManufacturers.length > 0 && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="manufacturers-tooltip">
                  <div style={{ textAlign: 'left' }}>
                    {hiddenManufacturers.map((manufacturer, index) => (
                      (manufacturer.manufacturerName)
                    )).join(", ")}

                  </div>
                </Tooltip>
              }
            >
              <span style={{ color: '#702C62', cursor: 'pointer', fontSize: "12px", fontWeight: "500", textDecoration: "underline", }}>
                +{hiddenManufacturers.length} More
              </span>
            </OverlayTrigger>
          )}
        </div>
      </div>
    )
  }

    const AccumulatorArrayList = (row) => {
    const displayLimit = 1;
    if (row.reportConfigAccumulatorMaps.length === 0) {
      return '-';
  }
    const displayedAccumulators = row.reportConfigAccumulatorMaps.slice(0, displayLimit);
    const hiddenAccumulators = row.reportConfigAccumulatorMaps.slice(displayLimit);
    return (
      <div>
        {displayedAccumulators.map((accumulator, index) => (
          <Badge
            key={index}
            pill
            bg="secondary"
            style={{
              marginRight: '8px',
              padding: '10px',
              color: "#555555",
              margin: "auto",
              width: "auto",
            }}
          >
            {accumulator.ceName}
          </Badge>
        ))}
        <div>
          {hiddenAccumulators.length > 0 && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="manufacturers-tooltip">
                  <div style={{ textAlign: 'left' }}>
                    {hiddenAccumulators.map((accumulator, index) => (
                      (accumulator.ceName)
                    )).join(", ")}

                  </div>
                </Tooltip>
              }
            >
              <span style={{ color: '#702C62', cursor: 'pointer', fontSize: "12px", fontWeight: "500", textDecoration: "underline", }}>
                +{hiddenAccumulators.length} More
              </span>
            </OverlayTrigger>
          )}
        </div>
      </div>
    )
  }
  const PharmacyArrayList = (row) => {
    const displayLimit = 1;

    if (row.reportConfigClientMaps.length === 0) {
      return '-';
  }
   
    const displayedManufacturers = row.reportConfigClientMaps.slice(0, displayLimit);
    const hiddenManufacturers = row.reportConfigClientMaps.slice(displayLimit);
    return (
      <div>
        {displayedManufacturers.map((manufacturer, index) => (
          <Badge
            key={index}
            pill
            bg="secondary"
            style={{
              marginRight: '8px',
              padding: '10px',
              color: "#555555",
              margin: "auto",
              width: "auto"
            }}
          >
            {manufacturer.phName}
          </Badge>
        ))}
        <div>
          {hiddenManufacturers.length > 0 && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="manufacturers-tooltip">
                  <div style={{ textAlign: 'left' }}>
                    {hiddenManufacturers.map((manufacturer, index) => (
                      (manufacturer.phName)
                    )).join(", ")}
                  </div>
                </Tooltip>
              }
            >
              <span style={{ color: '#702C62', cursor: 'pointer', fontSize: "12px", fontWeight: "500", textDecoration: "underline", }}>
                +{hiddenManufacturers.length} More
              </span>
            </OverlayTrigger>
          )}
        </div>

      </div>
    )
  }

  let mainCol = [
    {
      dataField: 'edit',
      text: 'Options',
      cellRenderer: (row) => cellRenderEdit(row),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },

    {
      dataField: 'reportName',
      text: 'Report Name',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.reportName),
    },
    {
      dataField: 'reportTypeName',
      text: 'Report Type',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.reportTypeName),
    },
    {
      dataField: 'frequencyDesc',
      text: 'Frequency',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.frequencyDesc),
    },
    {
      dataField: 'startDate',
      text: 'Start Date',
      sort: true,
      width: 200,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.startDate),
    },
    {
      dataField: 'endDate',
      text: 'Term Date',
      sort: true,
      width: 200,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row, col) => formatter(row, col, "date"),
      //cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      edit: true
    },
    {
      dataField: 'reportConfigMfgMaps',
      text: 'Manufacturers',
      sort: false,
      width: 200,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      edit: true,
      cellRenderer: (row, col) => ManufacturesArrayList(row),
    },
    
    {
      dataField: 'reportConfigClientMaps',
      text: 'Pharmacy',
      sort: false,
      width: 140,
      show: appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09"? false :true,
      inputType: 'text',
      hideColFilter: true,
      
      cellRenderer: (row, col) => PharmacyArrayList(row),
    },

     {
      dataField: 'reportConfigAccumulatorMaps',
      text: 'Accumulator',
      sort: false,
      width: 140,
      show: appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09"? true : false,
      inputType: 'text',
      hideColFilter: true,
      
      cellRenderer: (row, col) => AccumulatorArrayList(row),
    },
    {
      dataField: 'claimTypeDesc',
      text: 'Claim Type',
      sort: false,
      width: 140,
      show: appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09"? false :true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.claimTypeDesc),
    },
    {
      dataField: 'netClaims',
      text: 'Net Claims Only',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.netClaims == "Y" ? "Yes" : "No"),
    },
    {
      dataField: 'npi',
      text: 'NPI',
      sort: false,
      width: 140,
      show: appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09"? true : false,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.npi),
    },

    {
      dataField: 'autoSend',
      text: 'Auto Send',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.autoSend == "Y" ? "Yes" : "No"),
    },
    {
      dataField: 'comments',
      text: 'Comments',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.comments),
    },
{
      dataField: 'createdDate',
      text: 'Created Date',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },

  ];
  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  const handleSort = (filter, hasColFilter) => {
    setState({
      filters: filter,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
      setSort(true)
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };
  const onHandelFilterChange = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  }

  const filterslist = [
        {
      filterType: "List",
      filterName: "Claim Type",
      filterdataFiled: "claimTypeDesc",
      filterOptions: [
        {
          "id": "A",
          "label": "All"
        },
        {
          "id": "C",
          "label": "Captured",

        },
        {
          "id": "NC",
          "label": "Non Captured",
        },
        {
        "id": "RP",
        "label":"Repleneshed"
        }
      ]
    },
    {
      filterType: 'List',
      filterName: 'Frequency',
      filterdataFiled: 'frequencyDesc',
      filterOptions: [
        {
          "id": "DL",
          "label": "Daily"
        },
        {
          "id": "WL",
          "label": "Weekly",

        },
        {
          "id": "BI",
          "label": "Bi-Weekly",
        },
        {
          "id": "ML",
          "label": "Monthly",
        },
        {
          "id": "QL",
          "label": "Quarterly",
        }
      ]
    }
  ]

  function buildFilters(reportId) {
      switch (reportId) {
        case "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09":
        case "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09":
        filterslist[0].filterOptions = [
          { id: "C", label: "Captured" }];
        filterslist[1].filterOptions =[
          { "id": "DL","label": "Daily"},
          { "id": "WL","label": "Weekly"},
          {"id": "ML", "label": "Monthly"}
          ,{"id": "QL","label": "Quarterly"
          }]
          break;
        case "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09":
          case "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09":
            filterslist[0].filterOptions = [
              { id: "C", label: "Captured" },
              {id:"RP", label:"Replenished"}];
            filterslist[1].filterOptions =[
              { "id": "DL","label": "Daily"},
              { "id": "WL","label": "Weekly"},
              {"id": "BI", "label": "Bi-Weekly",}]
          break;
          case "OFNzN0lSaS9pK2FzKzRSdzRaM29ZUT09":
            case "cEJmc25WQm82QUNCLy85blNIWCtmQT09":
              case "ejkwVkJObUJzbEM4WDRPRGhBK3FkUT09":
                case  "WWdDbzZzMXNHaGVMS3JtNEMva1ZBdz09":
                  case "Rm9kNDFrcFlpMnJ6d2duMndLaUtJUT09":
                    case "azlRUVFPRlo3MzVRbitDY0NoZHRQQT09":
                      case "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09":
                        case "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09":
                          case "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09":
                  filterslist[0].filterOptions = [
                     {"id": "A","label": "All"},
                     {"id": "C","label": "Captured"},
                     {"id": "NC","label": "Non Captured",},];  
                  filterslist[1].filterOptions =[
                    { "id": "DL","label": "Daily"},
                    { "id": "WL","label": "Weekly"},
                    {"id": "BI", "label": "Bi-Weekly",}]
                  break;
                  default:
          // default: show all
          filterslist
          break;
      }
    
       return appid === "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09"
        ? filterslist.filter((f) => f.filterdataFiled !== "claimTypeDesc")
        : filterslist;
    }
  return (
    <div>
      {loading && <Loader opacity={0.01} color='black' ConfigTable />}
      <div className="d-flex justify-content-between section-devider-border pb-2">
        <h3 className='font-20'>Search Results
          {totalSize > 0 &&
            <span className='f-18 text-primary font-weight-700 ms-1'>({totalSize})</span>}
        </h3>
        <span style={{ cursor: "pointer" }} onClick={toggleSider}>
          <img collapseSider src={!collapseSider ? collapse : collapseclose} className="" />
        </span>
      </div>
      <div>
        <Filters filterslist={buildFilters(reportId)}
          onHandelFilterChange={onHandelFilterChange}
          filters={filters}
          onSearch={onSearch}
          filtershow={filtershow}
          setFilterShow={setFilterShow}
          setStartPage={setStartPage}
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          totalRecords={totalSize}
          ceid={ceid}
        />
      </div>
      <div
        className='table-card scroll-table position-relative border-0 rounded pt-0'
        fixed-height={tableData && tableData.length > 0 ? 'fixed-height' : 'default'}
      >
        <ReactStrapTable
          id='configuration-table'
          height={550}
          fixedColumn
          width={1200}
          data={tableData}
          columns={mainCol}
          handelAddCoveredEntity={handelAddCoveredEntity}
          onExport={onExport}
          filters={filters}
          totalRecords={totalSize}
          pageSize={filters.pageSize}
          currentPage={filters.currentPage}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          handleSort={handleSort}
          hasDefaultPagination={true}
          startPage={startPage}
          setStartPage={setStartPage}
          hasExportPermission={true}
          isConfigurationTable={true}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          sort={sort}
        />
      </div>
      <Drawer
        direction="end"
        title="Configured Settings"
        isOpen={isOpenView}
        toggle={toggleView}
        size="lg"
      >
        <ViewConfigurations rowData={selectedRow}  setOpenView={setOpenView}/>
      </Drawer>

    </div>
  )
}

export default ConfigurationTable